import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const EmpresasPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Socios - Empresas</PageTitle>
      <View />
    </>
  );
};

export { EmpresasPage };
